export const maskTelefone = (value) => {
  //Removaluee tudo o que não é dígito
  value = value.replace(/\D/g, '');

  //(00) 1111-1111
  if (value.length <= 10) {
    value = value.replace(/(\d{2})(\d)/, '($1) $2');

    value = value.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    //(00) 91111-1111

    value = value.replace(/(\d{2})(\d)/, '($1) $2');

    value = value.replace(/(\d{5})(\d)/, '$1-$2');
  }

  if (value.length > 15) return value.slice(0, 15);

  return value;
};
